<!-- src/pages/MyPage.vue -->
<script setup>
definePage({ meta: { layout: 'mypage' } });
import {
  paymentOwnDetail,
  subscrCancelReason,
  subscrCancel,
  paymentCancel,
  historyPointDetail,
} from '@/api/PaymentApi';
import { formatCustomDate } from '@/composables/functions';
import { ref, defineEmits } from 'vue';

//Alert
import AlertComponent from '@/components/common/Alert.vue';
import ConfirmComponent from '@/components/common/Confirm.vue';
import IconHeaderClose from '@/components/svg/IconHeaderClose.vue';
import MobileHeader from '@/components/common/MobileHeader.vue';
import { useBackLayer } from '@/composables/useAppBack';

const route = useRoute();
const router = useRouter();

const isWebView = ref(false);
onMounted(() => {
  isWebView.value = !!window.ReactNativeWebView;
});

const payOwnData = ref(null);
const id = ref(null);
const stepMode = ref('step1');
const productType = ref(null);
const tabType = ref('IMG');

//TODO: 목록
const getView = async () => {
  const params = {};
  params.productType = productType.value;
  //const data = await paymentOwnDetail(id.value, params)
  //payOwnData.value = data
  if (productType.value === 'POINT') {
    const data = await historyPointDetail(id.value, params);
    payOwnData.value = data;
  } else {
    const data = await paymentOwnDetail(id.value, params);
    payOwnData.value = data;
  }
};

const popUnsubscribeBox = ref(false);

onMounted(async () => {
  id.value = route.params?.id;
  productType.value = route.query.productType;
  tabType.value = route.query.tabType;

  await getView();
  await reasonList();
});
const getList = () => {
  const page = route.query.page || 1;
  router.push(
    `/mypage/history?tabType=${tabType.value}&productType=${productType.value}&page=${page}`,
  );
};

const receiptUrl = ref(null);
const popReceiptBox = ref(false);

const goReceipt = () => {
  const url = payOwnData.value?.paymentDetail?.receiptUrl;
  if (!url) return;

  // 모바일에서는 닫기 버튼이 있는 팝업으로 표시
  if (window.innerWidth <= 768 || isWebView.value) {
    receiptUrl.value = url;
    popReceiptBox.value = true;
  } else {
    window.open(url, '_blank');
  }
};

const closeReceipt = () => {
  popReceiptBox.value = false;
  receiptUrl.value = null;
};

// 숫자에 천 단위 구분 쉼표를 추가하는 함수
const formatNumber = (num) => {
  if (num < 1000) return num;
  return new Intl.NumberFormat().format(num);
};

const openUnsubscribe = () => {
  stepMode.value = 'step1';
  popUnsubscribeBox.value = true;
};
const close = () => {
  popUnsubscribeBox.value = false;
};
const articleContent = ref(null);
const contentPlaceholder = `서비스 향상에 도움이 되도록 구체적인 탈퇴 이유를 적어주시면 감사하겠습니다.`;

const reasonListData = ref(null);
const selectedReason = ref(null);

const reasonList = async () => {
  const params = { size: -1, page: 1 };
  const data = await subscrCancelReason(params);
  reasonListData.value = data.content;
};

const maxCharCount = 200;
const charCount = computed(() => articleContent.value?.length || 0); // 기본값 0

const checkMaxLength = () => {
  if (articleContent.value.length > maxCharCount) {
    articleContent.value = articleContent.value.slice(0, maxCharCount);
  }
};

const isTextareaDisabled = computed(() => {
  return selectedReason.value !== 7;
});

const next = () => {
  if (selectedReason.value === null) {
    //showDialogAlert('해지 사유를 선택해주세요.')
    //openUnsubscribe()
    stepMode.value = 'step2';
  } else {
    stepMode.value = 'step2';
  }
};

const save = async () => {
  const params = {
    reasonId: selectedReason.value,
    ...(articleContent?.value !== null && { customReason: articleContent.value }),
  };

  const data = await subscrCancel(params);
  if (data?.status === 'success') {
    showDialogAlert('정상적으로 정기결제가 해지되었습니다.', '', '', getList);
    //router.push('/mypage/subscrPayment')
  } else {
    showDialogAlert(data?.message);
  }
};

const dialogAlert = ref(null);
const dialogTitle = ref('');
const dialogTitle2 = ref('');
const dialogText = ref('');
const dialogNextUrl = ref(null);
const dialogDoFun = ref(null);

const dialogConfirm = ref(null);
const cancelOrderId = ref(null);

//FIX 알림창
const showDialogAlert = (title, text = '', nextUrl = '', doFun = null) => {
  dialogTitle.value = title;
  if (text) {
    dialogText.value = text;
  } else {
    dialogText.value = '';
  }
  dialogNextUrl.value = nextUrl;
  dialogDoFun.value = doFun;
  dialogAlert.value.openAlertDialog();
};

const paymentPointCancel = async (orderId) => {
  cancelOrderId.value = orderId;
  dialogTitle.value = '포인트 충전을 ';
  dialogTitle2.value = '취소 하시겠습니까?';
  dialogText.value = '확인';
  dialogNextUrl.value = onConfirmPaymentCancel;
  dialogConfirm.value.openConfirmDialog();
};

const onConfirmPaymentCancel = async () => {
  const orderId = cancelOrderId.value;
  const params = {};
  try {
    const data = await paymentCancel(orderId, params);
    if (data?.orderStatus) {
      showDialogAlert('포인트 충전이 취소 되었습니다.', '', '', getList);
    }
  } catch {
    showDialogAlert('오류가 발생했습니다.');
  }
};

const emit = defineEmits(['router-change-event']);

const test = () => {
  emit('router-change-event');
};

/** 뒤로가기: 항상 이용중인 서비스 목록으로 */
const handleBack = () => {
  router.replace('/mypage/history');
};

useBackLayer({
  id: 'mypage-payment-receipt',
  isOpen: popReceiptBox,
  closeFromBack: closeReceipt,
});

useBackLayer({
  id: 'mypage-payment-unsubscribe',
  isOpen: popUnsubscribeBox,
  closeFromBack: close,
});
</script>

<template>
  <div class="my-info-wrap">
    <MobileHeader title="결제 상세" :show-back="true" :show-menu="!isWebView" @back="handleBack" />
    <div class="my-tit-box com-bg-my-box h-small">
      <div class="tit">이용중인 서비스</div>
      <div class="path">
        <ul>
          <li>홈</li>
          <li>마이페이지</li>
          <li>낭만 서비스</li>
          <li @click="test()">이용중인 서비스</li>
        </ul>
      </div>
    </div>
    <div class="myinfo-box com-bg-my-box">
      <!-- {{ payOwnData }} -->

      <div class="payment-detail-box">
        <div class="order-box">
          {{ payOwnData?.orderId }}
        </div>
        <div class="title-info-box">
          <div class="text-box">
            <div class="date">{{ formatCustomDate(payOwnData?.approvedAt) }}</div>
            <div class="title">
              <span v-if="payOwnData?.productDetail?.productType === 'POINT'">
                {{ payOwnData?.productDetail?.description }}
              </span>
              <span v-else>{{ payOwnData?.productName }}</span>
            </div>

            <div class="date2" v-if="payOwnData?.productDetail?.productType !== 'POINT'">
              {{ formatCustomDate(payOwnData?.productDetail?.startDate) }} ~
              {{
                payOwnData?.productDetail?.endDate
                  ? formatCustomDate(payOwnData?.productDetail?.endDate)
                  : ''
              }}
            </div>
          </div>
          <div class="btn-box">
            <button
              v-if="
                payOwnData?.productDetail?.productType === 'SUBSCRIPTION' &&
                payOwnData?.productDetail?.planStatus === 'ACTIVE' &&
                payOwnData?.productDetail?.subscriptionCancelDate === null
              "
              @click="openUnsubscribe()"
            >
              구독해지
            </button>
            <span class="txt1" v-if="payOwnData?.productDetail?.subscriptionCancelDate">
              구독해지일자 {{ payOwnData?.productDetail?.subscriptionCancelDate }}</span
            >

            <button
              v-if="
                payOwnData?.productDetail?.productType === 'POINT' &&
                payOwnData?.orderStatus === 'SUCCESS' &&
                payOwnData?.productDetail?.usedAt === null &&
                payOwnData?.paymentSource === 'PG'
              "
              @click="paymentPointCancel(payOwnData.orderId)"
            >
              취소하기
            </button>
            <span
              class="txt1"
              v-if="
                payOwnData?.productDetail?.productType === 'POINT' &&
                payOwnData?.orderStatus === 'CANCELED'
              "
            >
              취소일자 {{ payOwnData?.productDetail?.updatedAt }}</span
            >
            <!-- <span v-if="payOwnData?.productType === 'SUBSCRIPTION' "></span> -->
          </div>
        </div>

        <div class="tit-box">
          <div class="text-box">결제내역</div>
          <div class="btn-box">
            <span v-if="payOwnData?.productDetail?.productType !== 'POINT'">
              <button class="line">결제수단변경</button>
            </span>
            <button
              v-if="payOwnData?.paymentSource === 'PG' && payOwnData?.paymentDetail?.receiptUrl"
              @click="goReceipt()"
            >
              영수증 보기
            </button>
          </div>
        </div>

        <div class="detail-box">
          <dl class="solid-line">
            <dt>실 결제금액</dt>
            <dd>
              <div class="">
                {{ formatNumber(payOwnData?.totalAmount) }}
                {{ payOwnData?.paymentSource === 'SMARTWEL' ? 'P' : '원' }}
              </div>
              <div
                v-if="
                  payOwnData?.paymentMethod === '카드' ||
                  payOwnData?.paymentMethod === '자동결제(카드)'
                "
              >
                <!-- [카드사] / 일시불 -->
                {{ payOwnData?.paymentDetail?.card?.cardCompany }} /
                {{
                  payOwnData?.paymentDetail?.card?.installmentPlanMonths
                    ? payOwnData?.paymentDetail?.card?.installmentPlanMonths
                    : '일시불'
                }}
              </div>
              <div v-else-if="payOwnData?.paymentMethod === '간편결제' && payOwnData?.cardCompany">
                <!-- [간편결제사] ([카드사]) / 일시불 -->
                {{ payOwnData?.paymentDetail?.easyPay?.provider }}
                ({{ payOwnData?.paymentDetail?.card?.cardCompany }}) /
                {{
                  payOwnData?.paymentDetail?.card?.installmentPlanMonths === 0
                    ? '일시불'
                    : payOwnData?.paymentDetail?.card?.installmentPlanMonths
                }}
              </div>
              <div v-else-if="payOwnData?.paymentMethod === '간편결제'">
                <!-- [간편결제사] / 일시불 -->
                {{ payOwnData?.paymentDetail?.easyPay?.provider }} /
                {{
                  payOwnData?.paymentDetail?.card?.installmentPlanMonths === 0
                    ? '일시불'
                    : payOwnData?.paymentDetail?.card?.installmentPlanMonths
                }}
              </div>
              <div
                v-else-if="
                  payOwnData?.paymentSource === 'APPLE' || payOwnData?.paymentSource === 'GOOGLE'
                "
              >
                <!-- [GOOGLE|APPLE] 구매 -->
                {{ payOwnData?.paymentSource === 'APPLE' ? 'Apple' : 'Google' }} 구매
              </div>
              <div v-else-if="payOwnData?.paymentSource === 'SMARTWEL'">
                <!-- [복지찬스] 복지포인트 — 할부 불가 결제 수단이라 일시불 표기 생략 -->
                복지포인트
              </div>
              <div v-else-if="payOwnData?.paymentMethod === '가상계좌'">
                <!-- [가상계좌] -->
                가상계좌
              </div>
              <div v-else-if="payOwnData?.paymentMethod === '계좌이체'">
                <!-- [(퀵)계좌이체] -->
                퀵계좌이체
              </div>
              <!-- 레거시 방식 -->
              <div v-else class="">
                {{ payOwnData?.paymentDetail?.card?.cardCompany }} /
                {{
                  payOwnData?.paymentDetail?.card?.installmentPlanMonths
                    ? payOwnData?.paymentDetail?.card?.installmentPlanMonths
                    : '일시불'
                }}
              </div>
              <!-- 레거시 방식 끝 -->
            </dd>
          </dl>
          <dl>
            <dt>정상가</dt>
            <dd>{{ formatNumber(payOwnData?.basePrice) }} 원</dd>
          </dl>
          <dl>
            <dt>혜택</dt>
            <dd>{{ formatNumber(payOwnData?.salePrice) }} 원</dd>
          </dl>
          <dl class="solid-line">
            <dt>합계</dt>
            <dd>{{ formatNumber(payOwnData?.amount) }} 원</dd>
          </dl>
          <dl v-if="payOwnData?.productDetail?.productType === 'POINT'" class="solid-line-2">
            <dt>{{ payOwnData?.orderStatus === 'CANCELED' ? '포인트 취소' : '포인트 전환' }}</dt>
            <dd>{{ formatNumber(payOwnData?.productDetail?.totalAmount) }} P</dd>
          </dl>
          <dl v-if="payOwnData?.productDetail?.productType === 'POINT'">
            <dt>{{ payOwnData?.orderStatus === 'CANCELED' ? '취소 포인트' : '구매 포인트' }}</dt>
            <dd>{{ formatNumber(payOwnData?.productDetail?.amount) }} P</dd>
          </dl>

          <dl
            v-if="
              payOwnData?.productDetail?.productType === 'POINT' &&
              payOwnData?.productDetail?.bonusAmount
            "
          >
            <dt>
              보너스 포인트
              <span v-if="payOwnData?.productDetail?.expiryDate" class="txt-red">
                유효기한 {{ payOwnData?.productDetail?.expiryDate }}
              </span>
            </dt>
            <dd>{{ formatNumber(payOwnData?.productDetail?.bonusAmount) }} P</dd>
          </dl>
        </div>
        <div class="point-info-box st-payment">
          <ul v-if="payOwnData?.productDetail?.productType === 'POINT'">
            <li>포인트 취소는 사용하지 않은 포인트 금액에 한하여 7일 이내 가능합니다.</li>
          </ul>
          <ul v-else>
            <li>
              자동결제는 월단위로 결제가 되며, 첫 결제하신 날짜와 동일한 날짜에 결제가 이루어집니다.
              해당일이 없는 경우, 해당월의 마지막날에 결제가 이루어 집니다.
            </li>
            <li>
              결제 후 미사용 시 7일 이내에 환불이 가능합니다.
              <button class="btn-txt-line">환불안내 바로가기</button>
            </li>
          </ul>
        </div>
        <div class="btn-com gap-xl center">
          <!-- <button class="btn-line w-large bg-w w-mid" @click="getList()">목록으로</button> -->
          <button class="btn-line w-large bg-w w-mid" @click="getList()">목록으로</button>
        </div>
      </div>
    </div>
  </div>

  <VDialog
    v-model="popUnsubscribeBox"
    class="v-dialog-sm dialog-st1"
    max-width="400px"
    @click:outside="close"
  >
    <VCard class="br16">
      <div class="pop-inner padding-tb">
        <div class="pop-tit-box tit-default">
          <div class="tit-text-d">구독해지</div>
          <button class="dial-close" @click="close"></button>
        </div>
        <div class="pop-body-box st-pd-32" v-if="stepMode === 'step1'">
          <div class="pop-sub-title-box">낭만만세력 이용권을 해지하시려는 이유를 알려주세요.</div>
          <div class="pop-reason-box">
            <div v-for="reason in reasonListData" class="row-box">
              <input
                :id="reason.reason_id"
                type="radio"
                class="radio"
                name="ques_type"
                v-model="selectedReason"
                :value="reason.reason_id"
                @change="handleChange"
              /><label :for="reason.reason_id" class="label font">{{ reason.reason }}</label>
            </div>
          </div>
          <div class="text-box">
            <v-textarea
              v-model="articleContent"
              :placeholder="contentPlaceholder"
              outlined
              no-resize
              rows="3"
              class="textarea custom-textarea"
              @input="checkMaxLength"
              :disabled="isTextareaDisabled"
            />
            <div class="char-count">{{ charCount }} / {{ maxCharCount }}</div>
          </div>
          <div class="pop-btn">
            <VRow>
              <VCol md="4" cols="12" class="pa-1">
                <VBtn type="submit" width="100%" @click="close"> 해지안함 </VBtn></VCol
              >
              <VCol md="8" cols="12" class="pa-1"
                ><VBtn
                  type="submit"
                  width="100%"
                  variant="outlined"
                  color="info"
                  :disabled="agree === false"
                  style="font-weight: 700"
                  @click="next()"
                >
                  해지 계속 진행
                </VBtn></VCol
              >
            </VRow>
          </div>
        </div>
        <div class="pop-body-box st-pd-32" v-if="stepMode === 'step2'">
          <div class="pop-sub-title-box bg-gray">
            현재 이용권 만료일은
            <span class="txt-point">
              {{ payOwnData?.endDate ? formatCustomDate(payOwnData.endDate) : '' }}</span
            >
            입니다.
          </div>
          <div class="step2-txt-01">정기결제를 해지 하시겠습니까?</div>
          <div class="step2-txt-02">
            정기결제를 해지해도 현재 사용 중인 이용권의 <br />
            만료일까지 추가 사주저장을 사용할 수 있습니다.
          </div>
          <div class="step2-txt-03">
            <div class="txt-nor">
              이용권 만료 후 사주 저장을 하는 경우, 일부 제약이 있을 수 있습니다.
            </div>
            <div class="txt-s">- 즐겨찾기 기능 <br />- 그룹관리 기능</div>
          </div>
          <div class="step2-txt-04">
            정기결제를 유지하면 자동으로 결제되어 <br />만료일 걱정없이 편하게 이용하실 수 있습니다.
          </div>
          <div class="pop-btn step-2">
            <VBtn type="submit" width="100%" @click="save"> 해지하기 </VBtn>
          </div>
        </div>
      </div>
    </VCard>
  </VDialog>
  <!-- 영수증 팝업 (모바일) -->
  <VDialog v-model="popReceiptBox" fullscreen :scrim="false" transition="dialog-bottom-transition">
    <VCard style="display: flex; flex-direction: column; height: 100%">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 16px;
          border-bottom: 1px solid #eee;
        "
      >
        <span style="font-size: 16px; font-weight: 600">영수증</span>
        <button
          @click="closeReceipt"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border: none;
            background: none;
            cursor: pointer;
          "
        >
          <IconHeaderClose />
        </button>
      </div>
      <iframe v-if="receiptUrl" :src="receiptUrl" style="flex: 1; width: 100%; border: none" />
    </VCard>
  </VDialog>

  <!--Alert창-->
  <AlertComponent
    ref="dialogAlert"
    :title="dialogTitle"
    :text="dialogText"
    :nextUrl="dialogNextUrl"
    :doFun="dialogDoFun"
  />
  <ConfirmComponent
    ref="dialogConfirm"
    :title="dialogTitle"
    :title2="dialogTitle2"
    :text="dialogText"
    :nextUrl="dialogNextUrl"
  />
</template>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .payment-detail-box {
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  /* 낭만센터 글 상세 헤더와 뒤로가기 아이콘 높이감 맞춤 */
  :deep(.mobile-header .mobile-header__back) {
    // transform: translateY(3px);
  }

  /* 모바일일 때 상단 여백 추가 */
  .my-info-wrap {
    padding-top: calc(var(--safe-area-top, 0px) + 52px);
    padding-bottom: calc(var(--safe-area-top, 0px));
    background-color: #fff;
  }

  /* PC 버전 타이틀 박스 숨김 */
  .my-tit-box {
    display: none;
  }

  /* 모바일 결제 상세 좌우 여백 */
  .myinfo-box {
    padding: 16px !important;
  }

  .payment-detail-box {
    width: 100% !important;
    padding: 0;
  }
}
</style>
